// extracted by mini-css-extract-plugin
module.exports = {"centerCol":"Banner_centerCol__2Dlch","wrapper":"Banner_wrapper__1YbFc"};